import React, { Component } from 'react'
import { Button, Row } from 'antd';
import { withRouter } from 'react-router-dom';

class ErrorPage extends Component {
    render() {
        return (
            <div style={{
                // minHeight:700,
                flex: 1,
                // backgroundColor:'#C33136',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                <Row type='flex' justify='center'>
                    <div>
                        <h1 style={{
                            textAlign: 'center',
                            // color:'white'
                        }}>Network Error</h1>
                        <center>
                            <img alt="Error " style={{
                                maxHeight: 200,
                                maxWidth: 200,
                                transform: 'translateX(30px)'
                            }} src={require('./server_error.svg')} />
                        </center>
                        <br></br>
                        {typeof this.props.onReload === 'function' &&
                            <span>
                                <center>
                                    {/* <Button type='danger'
                                        onClick={() => { this.props.history.goBack() }}
                                        style={{ marginLeft: 4, marginRight: 4 }}
                                    >Go Back</Button> */}
                                    <Button type='primary'
                                        onClick={() => { this.props.onReload() }}
                                    >Reload</Button>
                                </center>
                            </span>}
                    </div>
                </Row>
            </div>
        )
    }
}

export default withRouter(ErrorPage)
